import { dashboardDomain } from "@dashboard-config"

const localDashboardOrigins = new Set(["http://localhost:3000", "http://127.0.0.1:3000"])

export function requireDashboardOrigin(request: Request): Response | null {
  const stage = process.env.PUBLIC_STAGE || process.env.VITE_PUBLIC_STAGE
  const expectedOrigins = dashboardAllowedOrigins(stage)
  const origin = request.headers.get("origin")
  if (origin) {
    return isDashboardOriginAllowed(origin, stage, expectedOrigins) ? null : forbiddenOriginResponse()
  }

  const host = request.headers.get("x-forwarded-host") ?? request.headers.get("host")
  if (!host) return null

  const protocol =
    request.headers.get("x-forwarded-proto") ?? (host.startsWith("localhost") ? "http" : "https")
  const requestOrigin = `${protocol}://${host}`
  return isDashboardOriginAllowed(requestOrigin, stage, expectedOrigins) ? null : forbiddenOriginResponse()
}

export function dashboardAllowedOrigins(stage = process.env.PUBLIC_STAGE || process.env.VITE_PUBLIC_STAGE) {
  if (!stage || stage === "local") return localDashboardOrigins
  return new Set([...localDashboardOrigins, `https://${dashboardDomain(stage)}`])
}

function isDashboardOriginAllowed(origin: string, stage: string | undefined, expectedOrigins: Set<string>) {
  if ((!stage || stage === "local") && /^http:\/\/(?:localhost|127\.0\.0\.1):\d+$/.test(origin)) {
    return true
  }
  return expectedOrigins.has(origin)
}

function forbiddenOriginResponse() {
  return Response.json({ error: "Dashboard origin not allowed" }, { status: 403 })
}
